import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Debt, DebtService } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { requiredValidator } from '../../validators';

@Component({
  providers: [CurrencyPipe],
  selector: 'app-close-modal',
  templateUrl: './close-modal.component.html',
})
export class CloseModalComponent {
  @Input() debt: Debt;
  active = false;
  form = new FormGroup({
    comments: new FormControl(null, [
      requiredValidator(),
      Validators.maxLength(10000),
    ]),
  });

  constructor(private debtService: DebtService) {}

  open() {
    this.active = true;
  }

  close() {
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.debtService
        .cancel(this.debt.id, {
          comments: this.form.value.comments,
        })
        .subscribe(() => window.location.reload());
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/debts/close-modal.component.ts